import React, { Component } from 'react'
import { apiProcess } from '../../api/api.js'
import MetaTags from '../../elements/meta/metaTags.js'
import { buildBikeURL } from '../../utils'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import {
  USER_SMALL_PARAMS,
  userPhotoID,
} from '../../../constants/images/sizesAndQuality'
import Truncate from 'react-truncate'
import cloudinary from 'cloudinary-core'
import './reviewFeed.css'
import { Columns, Container, Header } from '../../elements'
import RatingStars from '../../elements/ratingStars'
import { trackPageView } from '../../elements/tracking/pagesAndMarketingTracking.js'
import ListRentCTA from '../listRentCTA/listRentCTA'
import { FeaturedReviews } from './featuredReviews'
import ReviewsSchema from 'components/elements/meta/reviewsSchema.js'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

class HomePage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      riderLoading: true,
      riderReviewData: [],
      ownerReviewData: [],
      ownerLoading: true,
      riderPage: 1,
      aggregatedRating: {}
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('home-page')
    this.setState({
      focusSearch: false,
    })
  }

  componentDidMount() {
    trackPageView('Reviews Feed Page', 'Marketing')
    this.getTopOwners()
    this.getReviewsFeed()
  }

  getReviewsFeed = () => {
    let apiURL = 'ratings/top_feed'
    let data = {
      page: this.state.riderPage,
    }
    apiProcess(
      apiURL,
      data,
      'latest-reviews',
      'Reviews Feed, Paginated from Reviews Page'
    )
      .then(
        function(responseData) {
          let currReviews = this.state.riderReviewData
          let combinedReviews = currReviews.concat(responseData.latest_ratings)
          this.setState({
            riderLoading: false,
            riderReviewData: combinedReviews,
            riderPage: this.state.riderPage + 1,
            aggregatedRating: responseData.aggregated_riders_ratings
          })
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({
            riderLoading: false,
            riderReviewData: [],
          })
        }.bind(this)
      )
  }

  loadAndGetReviewsFeed = () => {
    this.getReviewsFeed()
  }

  getTopOwners = () => {
    let apiURL = 'ratings/owners_top_feed'
    let data = false
    apiProcess(apiURL, data, 'top-owners', 'Top Owners from Reviews Page')
      .then(
        function(responseData) {
          let ownerReviews = responseData.top_rated_owners

          if (ownerReviews.length > 10) {
            ownerReviews.length = 10
          }

          this.setState({
            ownerLoading: false,
            ownerReviewData: ownerReviews,
          })
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({
            ownerLoading: false,
            ownerReviewData: [],
          })
        }.bind(this)
      )
  }

  getAvatarID = (avatarObject) => {
    //this is a hack to fix Dave's weird table object

    if (avatarObject.hasOwnProperty('table')) {
      return avatarObject.table.cloudinary_public_id
    } else {
      return avatarObject.cloudinary_public_id
    }
  }

  render() {
    const {
      riderReviewData,
      ownerReviewData,
      ownerLoading,
      riderLoading,
      aggregatedRating
    } = this.state

    return (
      <>
        <MetaTags
          title="Twisted Road Reviews | Highest Rated Motorcycle Rentals in the USA"
          description="Rent any motorcycle you want, wherever you want it, from our nationwide community of local bike owners, or make extra money renting out your motorcycle."
          url={'/'}
          type="company"
          notShowKeywords={true}
          event_url="https://www.twistedroad.com/reviews"
        />
        <ReviewsSchema
          ratingValue={aggregatedRating.average_rating}
          ratingCount={aggregatedRating.total_rating_count}
        />
        <Container className="medium review-header-wrap">
          <Columns className="is-centered">
            <Columns.Column size={12} className="has-text-centered">
              <Header
                renderas="h1"
                size={1}
                className="has-text-weight-extra-bold"
              >
                Helping everyone ride is our passion.
              </Header>
              <h2 className='subtitle is-3'>
                Our renters and owners can't stop raving about Twisted Road!
              </h2>
              <img
                className="reviews-banner"
                src="https://res.cloudinary.com/twisted-road/image/upload/q_82/v1573069688/frontend_assets/marketing/reviewsBanner.jpg"
                alt="Our renter and owner community"
              />
              <p className="reviews-caption">
                Renters and Owners living together in harmony.
              </p>
            </Columns.Column>
          </Columns>
        </Container>
        <div className="reviews-feed-stats has-text-centered">
          <Columns>
            <Columns.Column>
              <p className="reviews-stars-callout">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </p>
              <p>97% of our reviews are 5 stars!</p>
            </Columns.Column>
          </Columns>
        </div>
        <Container className="reviews-feed-main large">
          <div className="main-reviews-area-header-wrap has-text-centered">
            <h3 className="tripleR">Our Recent Rider Reviews</h3>
          </div>
          <Columns>
            <Columns.Column size={8}>
              <Columns>
                {riderLoading && (
                  <img
                    src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/search/searchNoResultsLoader.gif"
                    alt="Loading"
                    className="reviews-loading-container"
                  />
                )}
                {riderReviewData.map((review, index) => {
                  return (
                    <Columns.Column size={4} className={'review-card'}>
                      <div className="review-card-inner">
                        <RatingStars
                          rating={review.rating_score}
                          showInfo={false}
                          size="large"
                        />
                        <p className="review-feed-body">
                          <Truncate lines={5} ellipsis={'...'}>
                            {review.description}
                          </Truncate>
                        </p>

                        <img
                          src={cl.url(
                            userPhotoID(
                              this.getAvatarID(review.rider.avatar_image)
                            ),
                            USER_SMALL_PARAMS
                          )}
                          className="is-avatar"
                          alt={review.rider.first_name}
                        />
                        <span className="is-inline-block has-text-weight-bold">
                          {review.rider.first_name}
                        </span>
                        <a
                          className="review-card-link"
                          href={buildBikeURL({
                            country:
                              review.motorcycle.location.country_abbreviation,
                            region:
                              review.motorcycle.location.region_abbreviation,
                            city: review.motorcycle.location.city,
                            year: review.motorcycle.year.toString(),
                            make: review.motorcycle.make,
                            model: review.motorcycle.model,
                            bikeID: review.motorcycle.pretty_id,
                          })}
                        >
                          {review.motorcycle.full_name}
                        </a>
                      </div>
                    </Columns.Column>
                  )
                })}
              </Columns>
            </Columns.Column>
            <Columns.Column size={3} offset={1} className="top-owners-wrap">
              <h3 className="has-text-weight-extra-bold is-size-4 mb-3">
                Highest Rated Owners
              </h3>
              {ownerLoading && (
                <img
                  src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1572480187/frontend_assets/search/searchNoResultsLoader.gif"
                  alt="Loading"
                  className="reviews-loading-container"
                />
              )}
              {ownerReviewData.map((owner, index) => (
                <Columns
                  className="owner-review-feed-block"
                  breakpoint="mobile"
                >
                  <Columns.Column
                    mobile={{ size: 3 }}
                    tablet={{ size: 3 }}
                    className="owner-review-feed-avatar"
                  >
                    <a href={'/users/' + owner.pretty_id}>
                      <img
                        src={cl.url(
                          userPhotoID(this.getAvatarID(owner.avatar_image)),
                          USER_SMALL_PARAMS
                        )}
                        alt={owner.first_name}
                        className="is-rounded"
                      />
                    </a>
                  </Columns.Column>
                  <Columns.Column
                    mobile={{ size: 9 }}
                    tablet={{ size: 9 }}
                    className="owner-avatar"
                  >
                    <RatingStars
                      rating={owner.reviews.ratings_average}
                      showInfo={false}
                      size="large"
                    />
                    <p className="owner-review-feed-name">{owner.first_name}</p>
                  </Columns.Column>
                </Columns>
              ))}
            </Columns.Column>
          </Columns>
        </Container>
        <ListRentCTA />
        <h2
          className="has-text-weight-extra-bold has-text-centered mb-6 title"
        >
          Featured Reviews
        </h2>
        <Container className="medium">
          <FeaturedReviews />
        </Container>
      </>
    )
  }
}

export default HomePage
